import * as DiscountActionTypes from '../actions/discounts';

import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.discounts, action) => {
    const { payload, type } = action;
    
    switch(type) {
        
        case DiscountActionTypes.LIST_DISCOUNTS:
        case DiscountActionTypes.LIST_DISCOUNTS_PENDING:
           return { ...state, discounts_loading: true }

        case DiscountActionTypes.LIST_DISCOUNTS_REJECTED:
           return {...state, discounts_loading: false, ...errorResponseHandler(payload, 'DiscountsList') }

        case DiscountActionTypes.LIST_DISCOUNTS_FULFILLED:
           return { ...state, discounts_loading: false, reload_discounts: false, discounts: payload.data }
        

        case DiscountActionTypes.CREATE_DISCOUNT:
        case DiscountActionTypes.CREATE_DISCOUNT_PENDING:
            return { ...state, create_discount_loading: true, reload_discounts: false }

        case DiscountActionTypes.CREATE_DISCOUNT_REJECTED:
            return {...state, create_discount_loading: false, ...errorResponseHandler(payload, 'CreateDiscount') }

        case DiscountActionTypes.CREATE_DISCOUNT_FULFILLED:
            return { ...state, create_discount_loading: false, new_discount: payload.data, reload_discounts: true }
            

        case DiscountActionTypes.SET_DISCOUNT:
        case DiscountActionTypes.SET_DISCOUNT_PENDING:
            return { ...state, set_discount_loading: true, reload_discounts: false }

        case DiscountActionTypes.SET_DISCOUNT_REJECTED:
            return {...state, set_discount_loading: false, ...errorResponseHandler(payload, 'SetDiscount') }

        case DiscountActionTypes.SET_DISCOUNT_FULFILLED:
            return { ...state, set_discount_loading: false, set_discount: payload.data, reload_discounts: true }
        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/discounts.js